import { useIdoPrintListStore } from 'src/stores/idoPrintList';
import { RuntimeStoreContext } from 'src/types/runtime/piniaRuntimeContext';

import { StatusEnum } from 'src/models/status/enums';

import { QueryStore } from 'src/util/query/QueryStore';

const fetchIdoPrintListByIdoAndInstanceId = (
	uniqueListIdentifier: string,
	_store: RuntimeStoreContext,
	queryStore: QueryStore,
	queryParameters: {
		idoId: number;
		instanceId: number;
	}
) => {
	const idoPrintListStore = useIdoPrintListStore();

	void idoPrintListStore.fetchThePrintList({
		idoId: queryParameters.idoId,
		instanceId: queryParameters.instanceId,
		queryStore: queryStore,
	});
};

const setTheStateForTheSelectedPrintAggregateIds = (
	_store: RuntimeStoreContext,
	_queryStore: QueryStore,
	queryParameters: {
		aggregateIds: string[];
		state: StatusEnum;
	}
) => {
	const idoPrintListStore = useIdoPrintListStore();

	idoPrintListStore.setTheStatusForPrintAggregateIds({
		aggregateIds: queryParameters.aggregateIds,
		status: queryParameters.state,
	});
};

export { fetchIdoPrintListByIdoAndInstanceId, setTheStateForTheSelectedPrintAggregateIds };
